import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import WarehouseDetailsLayout from "@/screens/Warehouses/components/WarehouseDetailsLayout"

export const Route = createFileRoute("/app/admin/warehouses/$warehouseId/_layout")({
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.WAREHOUSES_VIEW]}>
      <WarehouseDetailsLayout />
    </PermissionContentWrapper>
  ),
})
